/* eslint-disable */

import request from '@/utils/request'

export function getListChargeServiceApi(query) {
  return request({
    url: '/config-service/v1/service-charge/list',
    method: 'get',
    params: query
  })
}

export function addChargeServiceApi(query) {
  return request({
    url: '/config-service/v1/service-charge/add',
    method: 'post',
     data: query
  })
}

export function updateChargeServiceApi(query) {
  return request({
    url: '/config-service/v1/service-charge/update',
    method: 'put',
     data: query
  })
}

export function deleteChargeServiceApi(query) {
  return request({
    url: '/config-service/v1/service-charge/delete',
    method: 'delete',
    data: query
  })
}
